import { AppAbilityType } from '../../../components/ability/ability';

const VIEW_NAVIGATION = {
    SETTLEMENT_FILES: '/settlement-files',
    SETTLEMENT_DATA: '/settlement-data',
};

export const settlementViewInterface = (userAbility: AppAbilityType) =>
    userAbility.can('view-route', '/settlement-files') && userAbility.can('view-route', '/settlement-data')
        ? [
              {
                  title: 'Data',
                  value: VIEW_NAVIGATION.SETTLEMENT_DATA,
                  tooltip: 'Data',
                  isVisible: true,
              },
              {
                  title: 'Files',
                  value: VIEW_NAVIGATION.SETTLEMENT_FILES,
                  tooltip: 'Files',
                  isVisible: true,
              },
          ]
        : [];
